// extracted by mini-css-extract-plugin
export default {"image":"ImageIcon_image__dM-Md","image-squircle":"ImageIcon_image-squircle__2gvCc","image-circle":"ImageIcon_image-circle__KBZLX","fallback":"ImageIcon_fallback__DcYet"};